import { useSessionStorage } from "usehooks-ts";

const FAQ_FEEDBACKS = "faq_feedbacks";

const useFeedback = (id: string) => {
    const [feedbacks, setFeedbacks] = useSessionStorage<Record<string, boolean>>(FAQ_FEEDBACKS, {});

    const updateFeedback = (isUseful: boolean) => {
        if (feedbacks[id]) return;

        setFeedbacks({ ...feedbacks, [id]: isUseful });
    };

    return {
        hasFeedback: typeof feedbacks[id] === "boolean",
        isUseful: feedbacks[id],
        updateFeedback,
    };
};

export default useFeedback;
